import statsPlot from "../../../../content/posts/data-release-notes/askenazi_trio_kit14_2022.12/ashstats.jsx";
import * as React from 'react';
export default {
  statsPlot,
  React
};